import http from "./api";

const sendDataToWhatsApp = (data) => {
    return http.post('Gallabox', data);
};

export const counsellingService = {
    sendDataToWhatsApp
}